import loadScript from './load-script'

export default function () {

    let mapObj = document.getElementById('pickup-map');

    if(mapObj) {
        loadScript("https://api-maps.yandex.ru/2.1/?lang=ru-RU&apikey=bf9541b8-2f3e-457f-a04e-ff4724a6b9eb", function () {
            ymaps.ready(function () {
                pickupMapInit();
            });
        });
    }

    function pickupMapInit(){

        let pickupMap;
        let myObjects = [];

        let pinSrc = mapObj.getAttribute('data-pin');
        let dataCoord = mapObj.getAttribute('data-coord').split(',');

        pickupMap = new ymaps.Map('pickup-map', {
            center: dataCoord,
            zoom: 16,
            controls: []
        });

        pickupMap.behaviors.disable("scrollZoom");

        let zoomControl = new ymaps.control.ZoomControl({options: { position: { right: 20, top: 10 }}});

        pickupMap.controls.add(zoomControl);

        let objectManager = new ymaps.ObjectManager();


        for (let i = 0, l = dataCoord.length; i < l; i++) {
            myObjects.push({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: dataCoord
                }
            });
        }

        objectManager.add(myObjects);
        pickupMap.geoObjects.add(objectManager);


        objectManager.objects.options.set({
            iconLayout: 'default#image',
            iconImageHref: pinSrc,
            iconImageSize: [40, 56],
            iconImageOffset: [-20, -56]
        });

    }

}
